<template lang="pug">
  .holiday-details
    Validate.name(v-model="name" :minLength="4")
      PTextField(label="nome" v-focus)

    Validate(v-model="date")
      PDatePicker(label="data" required name="admission")

    .region
      RegionTags(
        v-model="region"
        :loading="false"
        :minNumberOfTags="1"
        ref="regionsComponent"
      )

    .pay-kind
      PSelect(v-model="payKind" :allowEmpty="false" labelItem="name" title="forma de pagamento")

    .custom-rules
      PSelect(v-model="customRules" :allowEmpty="false" labelItem="name" useCommon="customRules"
        :title="$ws('customRules')" noSelectedOption="sem regra")

    .checks
      PCheckbox(v-model="repeats" label="feriado fixo")
      PCheckbox(v-model="isRestDay" label="feriado com folga")

    .buttons
      PButton(color="success" size="md" @click="save" :loading="saving" block) {{ holiday ? 'salvar' : 'adicionar'}}
      PButton(color="danger" size="md" @click="close()" block) cancelar

</template>

<script>
import moment from 'moment'
import RegionTags from 'src/components/Company/details/RegionTags'
import {formatDateToSend} from 'src/utils'
import { useValidationsMixin } from 'src/common/validations'

export default {
  name: 'HolidayDetails',
  components: {RegionTags},
  mixins: [useValidationsMixin({deepCheck: false})],
  props: {
    holiday: {default: null}
  },
  created () {
    if (this.holiday) {
      this.name = this.holiday.name
      this.date = moment(this.holiday.date).toDate()
      this.region = this.holiday.fullRegion
      this.customRules = this.holiday.customRules
      this.repeats = this.holiday.repeats
      this.isRestDay = this.holiday.isRestDay

      const payKind = this.payKind.loaded.find(i => i.id === this.holiday.payKind)
      if (payKind) {
        this.payKind.selected = payKind
      }
    }
  },
  data () {
    return {
      saving: false,
      name: '',
      date: '',
      region: [],
      customRules: {
        selected: null
      },
      repeats: true,
      isRestDay: false,
      payKind: {
        selected: {id: 'normal', name: 'normal'},
        loaded: [
          {id: 'normal', name: 'normal'},
          {id: 'extra', name: 'extra'},
          {id: '100', name: 'extraordinária'},
          {id: 'special', name: 'especial'}
        ]
      }
    }
  },
  methods: {
    async save () {
      if (!this.isAllValid()) {
        this.displayAllErrors()
        return
      } else if (this.$refs.regionsComponent.isInvalid) {
        this.$swal({type: 'error', text: 'Esta região não é válida.'})
        return
      }
      this.saving = true

      const params = this.holiday ? {id: this.holiday.id} : {}

      try {
        await this.$API.holiday.save(
          params,
          {
            ...params,
            customRules: this.customRules.selected ? this.customRules.selected.id : 'none',
            date: formatDateToSend(this.date),
            isRestDay: this.isRestDay,
            name: this.name,
            payKind: this.payKind.selected.id,
            region: this.region[this.region.length - 1].id,
            repeats: this.repeats
          }
        )
        this.$modalDeSucesso(`Feriado ${this.holiday ? 'editado' : 'adicionado'} com sucesso`)
        this.close(true)
      } catch (e) {
        console.error(e)
        this.$modalDeErro(e?.data?.error ? e.data.error : 'Não foi possível salvar o feriado')
      }
      this.saving = false
    },
    close (reloadTable = false) {
      this.$emit('close', reloadTable)
    }
  }
}
</script>

<style scoped lang="scss">
.holiday-details {
  display: grid;
  grid-template-columns: 1fr 1fr 0.7fr 0.5fr;
  column-gap: 10px;
  row-gap: 10px;

  .pay-kind {
    grid-row: 2;
    grid-column: 1;
  }
  .custom-rules {
    grid-row: 2;
    grid-column: 2;
  }
  .checks, .buttons {
    align-items: flex-end;
    margin-bottom: 13px;
  }

  .region {
    grid-column: 3/5;
    display: grid;
    align-items: flex-end;
    padding-bottom: 13px;
  }

  .checks {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row: 2;
    grid-column: 3;
  }

  .buttons {
    grid-column: 4;
    grid-row: 2;
    display: grid;
    grid-auto-flow: column;
    column-gap: 1px;
  }
}
</style>
